'use es6';

import ActionTypes from '../constants/ActionTypes';
export default function installStatusModalReducer(installStatusModal, action) {
  switch (action.type) {
    case ActionTypes.DISMISSED_INSTALL_STATUS_MODAL:
      return installStatusModal.merge({
        goodId: '',
        open: false
      });

    case ActionTypes.OPEN_SLOW_DELIVERY_MODAL:
      return installStatusModal.merge({
        goodId: action.payload.goodId,
        open: true
      });

    default:
      return installStatusModal;
  }
}